<h2 mat-dialog-title>Cadastro de Usuário</h2>
<mat-dialog-content class="mat-typography">
  <div class="col-md-12">
    <page-alert [message]="messageError | translater" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

    <form [formGroup]="form" class="example-form">
      <div>
        <mat-card style="display: flex; flex-direction: column; margin: 2vh 0 auto">
          <page-alert
            message="Usuário registrado com sucesso, confirmação de email enviada!"
            *ngIf="successLogin && submitted"
            alertClass="alert-success"
          ></page-alert>
          <page-alert message="Falha ao registrar usuário!" *ngIf="!successLogin && submitted" alertClass="alert-danger"></page-alert>

          <mat-form-field appearance="outline">
            <mat-icon matSuffix>face</mat-icon>
            <mat-label>Nome</mat-label>
            <input matInput placeholder="Nome do usuário" formControlName="name" />
            <mat-error *ngIf="form.get('name')?.hasError('required')"> O nome é obrigatório. </mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('pattern')"> Padrão de nomenclatura não permitido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Cargo/Ocupação</mat-label>
            <mat-select formControlName="occupation">
              <mat-option value="Administrador">Administrador</mat-option>
              <mat-option value="Coordenador">Coordenador</mat-option>
              <mat-option value="Colaborador">Colaborador</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('occupation')?.hasError('required')"> O cargo é obrigatório. </mat-error>
          </mat-form-field>

          <div *ngIf="form.get('occupation')?.value" class="alert-box"><strong>Atenção:</strong> {{ getOccupationMessage() }}</div>

          <mat-form-field appearance="outline">
            <mat-icon matSuffix>account_circle</mat-icon>
            <mat-label>Email</mat-label>
            <input matInput placeholder="Username or email" formControlName="email" />
            <mat-error *ngIf="form.get('email')?.hasError('required')"> O email é obrigatório. </mat-error>
            <mat-error *ngIf="form.get('email')?.hasError('email')"> Email inválido. </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Senha</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Esconder Senha'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('password')?.hasError('invalidPassword')">
              A senha deve conter pelo menos 1 número, 1 letra maiúscula, 1 letra minúscula e caracteres especiais.
            </mat-error>
            <mat-error *ngIf="form.get('password')?.hasError('required')"> A senha é obrigatória. </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Confirmar Senha</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password_confirmation" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Esconder Senha'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('password_confirmation')?.hasError('required')"> A confirmação da senha é obrigatória. </mat-error>
            <mat-error *ngIf="form.hasError('mismatch')"> As senhas não coincidem. </mat-error>
          </mat-form-field>
        </mat-card>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button  color="primary" (click)="register()" class="mt-2" [disabled]="form.invalid">Criar Usuário</button>
</mat-dialog-actions>
